import { useEffect, useRef } from 'react';

import {
	type DiscountApplicationState,
	sendDiscountEvent,
} from '@/lib/tracking/discount';
import { type IDirectDiscount } from '@/types/content';

/**
 * Sends a discount event to FullStory each time the application state
 * changes. Repeated attempts with the same outcome (for example several
 * unrecognised codes in a row) produce a single event.
 */
export const useSendDiscountEvent = (
	applicationState: DiscountApplicationState,
	applicationContext: string,
) => {
	useEffect(() => {
		sendDiscountEvent(applicationState, applicationContext);
	}, [applicationState, applicationContext]);
};

/**
 * Sends one event per page load saying whether the visitor arrived with a
 * discount applied, unrecognised, or none at all.
 */
export const useSendDiscountPageLoadEvent = (
	appliedDiscount: IDirectDiscount | null | undefined,
) => {
	const sent = useRef(false);
	useEffect(() => {
		if (sent.current) return;
		sent.current = true;
		const discountState =
			appliedDiscount === undefined
				? 'NOT_PROVIDED'
				: appliedDiscount === null
					? 'UNRECOGNISED'
					: 'APPLIED';
		sendDiscountEvent(discountState, 'PAGE_VISIT');
	}, [appliedDiscount]);
};
